import React from "react";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => (
  <a
    href="https://wa.me/919000000000?text=Hi%20LEMCE%2C%20I%20need%20help%20choosing%20a%20size"
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with LEMCE on WhatsApp"
    data-testid="whatsapp-btn"
    className="fixed bottom-6 right-6 z-40 w-12 h-12 flex items-center justify-center bg-lemce-matte text-lemce-ivory rounded-full shadow-lg hover:scale-105 hover:bg-lemce-charcoal transition-all duration-300"
  >
    <MessageCircle className="w-5 h-5" strokeWidth={1.5} />
  </a>
);

export default WhatsAppButton;
